export default {
    postCheckEmail: { method: 'post', url: 'auth/check-email' },
}
